<template>
  <div>
    <transition name="media-scale">
      <div class="media-scale">
        <el-dialog
          v-bind="$attrs"
          v-on="$listeners"
          v-drag
          :key="'dialog'"
          :visible="isShowCountDown"
          :modal="false"
          :close-on-click-modal="false"
          :title="$t('countDown.计时')"
          width="400px"
          class="dialog-dark dialog-center form-dark"
          @open="onOpen"
          @close="onClose"
        >
          <el-form
            ref="elForm"
            :model="form"
            :rules="rules"
            label-position="right"
            label-width="100px"
            size="small"
            style="text-align: left"
            @submit.native.prevent
          >
            <el-form-item :label="$t('countDown.计时时长')" prop="duration">
              <el-input
                v-model.number="form.duration"
                :placeholder="$t('countDown.DP')"
                class="inputTime"
                type="number"
              ></el-input>
              <span class="second">{{ $t("countDown.分钟") }}</span>
            </el-form-item>
            <el-form-item :label="$t('countDown.计时方式')" prop="timeType">
              <el-radio-group
                v-model="form.timeType"
                size="mini"
                class="radio-group-mini"
              >
                <el-radio :label="0">{{ $t("countDown.倒计时") }}</el-radio>
                <el-radio :label="1">{{ $t("countDown.正计时") }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label-width="0" style="text-align: center">
              <el-button
                :loading="loading"
                class="button-mini"
                size="mini"
                type="primary"
                @click="onSubmit"
                >{{ $t("countDown.开始计时") }}</el-button
              >
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </transition>
    <transition name="media-scale"> </transition>
  </div>
</template>

<script>
import { Form, FormItem, Input, Radio, RadioGroup } from "element-ui";
import { mapGetters } from "vuex";
import { startCD } from "@/api/liveRequest/countDown";
import { getParameter } from "@/utils/global";
export default {
  name: "CountPopup",
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  data() {
    return {
      liveId: getParameter("liveId"),
      loading: false,
      form: {
        duration: "",
        timeType: 0,
      },
    };
  },
  computed: {
    ...mapGetters(["isShowCountDown"]),
    rules() {
      var checkDuration = (rule, value, callback) => {
        setTimeout(() => {
          if (!Number.isInteger(value)) {
            callback(new Error(this.$t("countDown.DP")));
          } else {
            if (value < 1 || value > 60) {
              callback(new Error(this.$t("countDown.DP")));
            } else {
              callback();
            }
          }
        }, 1000);
      };
      return {
        duration: [
          {
            required: true,
            message: this.$t("countDown.DP"),
            trigger: "blur",
          },
          {
            validator: checkDuration,
            message: this.$t("countDown.DP"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    onOpen() {},
    onClose() {
      this.$refs.elForm.resetFields();
      this.$store.commit("SET_SHOW_COUNT_DOWN", false);
    },
    onSubmit() {
      this.$refs.elForm.validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async submit() {
      this.loading = true;
      try {
        await startCD(Object.assign({}, this.form, { webcastId: this.liveId }));
      } catch (error) {
        this.$message.error("计时失败, 请重试");
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-dark {
  ::v-deep {
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
    }

    input[type="number"] {
      -moz-appearance: textfield;
    }

    .el-form-item__label {
      margin-right: 3px;
    }
  }
}
.inputTime {
  width: 196px;
}
.second {
  font-size: 12px;
  margin-left: 12px;
}
</style>
